export default "__VITE_ASSET__Ctxfcu21__"